// onhover navigation header menu change
let items = document.querySelectorAll(".header__inline-menu details");
items.forEach((item) => {
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
  });
  item.addEventListener("mouseleave", () => {
    // Delay the removal of "open" attribute to check if another details element is being hovered
    setTimeout(() => {
      if (!item.matches(":hover")) {
        item.removeAttribute("open");
      }
    }, 100);
  });
});

// back-to-top scroll button code
document.addEventListener("DOMContentLoaded", function() {
  var scroll_top_btn = document.getElementById("main_first_btn");
  scroll_top_btn.style.display = "none";
});
window.addEventListener("scroll", function() {
  var scroll_top_btn = document.getElementById("main_first_btn");
  if (window.scrollY > 300) {
    scroll_top_btn.style.display = "block";
  } else {
    scroll_top_btn.style.display = "none";
  }
});
document.getElementById("main_first_btn").addEventListener("click", window_scroll, false);
function window_scroll() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

// All external URL links on Shopify should open up a new tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

//----404 page redirect to homepage----//
document.addEventListener("DOMContentLoaded", function () {
  var canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink.href.includes("404")) {
    if (canonicalLink.href.includes('fr')) {
      window.location.href = "https://magnumicecreambrands.ca/fr";
    } else {
      window.location.href = "https://magnumicecreambrands.ca/";
    }    
  }
});

//----Magnum/Breyers brand logo redirect to brand landing page code starts----//
document.addEventListener("DOMContentLoaded", function() {
  var canonicalLink = document.querySelector('link[rel="canonical"]');
  var logoLink = document.querySelector(".brand_logo_link .cstm_header_design .header__heading-link");
  var logoImages = document.querySelectorAll(".brand_logo_link .cstm_header_design .header__heading-link img");
  // Add click event listener for each logo image
  logoImages.forEach(function(logoImage) {
    if (canonicalLink.href.includes("fr")) {
      logoImage.addEventListener("click", function(event) {
        console.log("logoImage clicked");
        var logoImageAttr = logoImage.getAttribute("data-logo-attr");
        // Prevent the default link behavior
        event.preventDefault();
        if (logoImageAttr === "global_logo") {
          window.location.href = "https://magnumicecreambrands.ca/fr";
        } else if (logoImageAttr === "magnum_logo") {
          window.location.href = "https://magnumicecreambrands.ca/fr/collections/magnum";
        } else if (logoImageAttr === "breyers_logo") {
          window.location.href = "https://magnumicecreambrands.ca/fr/collections/breyers";
        }
      });
    } else {
      logoImage.addEventListener("click", function(event) {
        console.log("logoImage clicked");
        var logoImageAttr = logoImage.getAttribute("data-logo-attr");
        // Prevent the default link behavior
        event.preventDefault();
        if (logoImageAttr === "global_logo") {
          window.location.href = "https://magnumicecreambrands.ca";
        } else if (logoImageAttr === "magnum_logo") {
          window.location.href = "https://magnumicecreambrands.ca/collections/magnum";
        } else if (logoImageAttr === "breyers_logo") {
          window.location.href = "https://magnumicecreambrands.ca/collections/breyers";
        }
      });
    }
  });
});
//----Magnum/Breyers brand logo redirect to brand landing page code ends----//